import proj4 from 'proj4';

type Position = [number, number, ...number[]];
type PolygonCoordinates = Position[][];
type MultiPolygonCoordinates = Position[][][];
interface LatLng {
  lat: number;
  lng: number;
}
interface XYCoordinate {
  x: number;
  y: number;
}

//  for polygon and multipolygon
export const convertCoordinates = (pCoordinates: PolygonCoordinates | MultiPolygonCoordinates): LatLng[] => {
  const convertedArray: LatLng[] = [];
  if (pCoordinates.length > 0) {
    if (Array.isArray((pCoordinates as MultiPolygonCoordinates)[0][0][0])) {
      // MultiPolygon
      (pCoordinates as MultiPolygonCoordinates).forEach((polygon) => {
        polygon.forEach((subArray) => {
          subArray.forEach((coordinates) => {
            convertedArray.push({
              lat: coordinates[1],
              lng: coordinates[0],
            });
          });
        });
      });
    } else {
      // Polygon
      (pCoordinates as PolygonCoordinates).forEach((subArray) => {
        subArray.forEach((coordinates) => {
          convertedArray.push({
            lat: coordinates[1],
            lng: coordinates[0],
          });
        });
      });
    }
  }
  return convertedArray;
};

export const roundNumber = (num: number, scale: number): number => {
  if (!('' + num).includes('e')) {
    return +(Math.round(Number(num + 'e+' + scale)) + 'e-' + scale);
  } else {
    var arr = ('' + num).split('e');
    var sig = '';
    if (+arr[1] + scale > 0) {
      sig = '+';
    }
    return +(Math.round(Number(+arr[0] + 'e' + sig + (+arr[1] + scale))) + 'e-' + scale);
  }
};

proj4.defs(
  'EPSG:2056',
  '+proj=somerc +lat_0=46.95240555555556 +lon_0=7.439583333333333 +k_0=1 +x_0=2600000 +y_0=1200000 +ellps=bessel +towgs84=674.374,15.056,405.346,0,0,0,0 +units=m +no_defs'
);

// To LV95 from WGS84 for 1 coordinate
export const wgs84ToLv95ForOneCoordinate = (pLng: number, pLat: number): XYCoordinate => {
  const source = 'EPSG:4326'; // WGS84
  const destination = 'EPSG:2056'; // LV95

  let [x, y] = proj4(source, destination, [pLng, pLat]);

  x = parseFloat(x.toFixed(2));
  y = parseFloat(y.toFixed(2));

  return { x, y };
};

// To WGS84 from LV95 for 1 coordinate
export const lv95ToWgs84ForOneCoordinate = (pX: number, pY: number): LatLng => {
  const source = 'EPSG:2056'; // LV95
  const destination = 'EPSG:4326'; // WGS84
  let [lng, lat] = proj4(source, destination, [pX, pY]);

  lng = roundNumber(lng, 8);
  lat = roundNumber(lat, 8);

  return { lng, lat }; // x, y
};

// Change coordinates from WGS84 to LV95
// export const changeCoordinatesFromWGS84ToLV95 = (pWGS84Coordinates) => {
//   return pWGS84Coordinates.map((coordinate) =>
//     wgs84ToLv95ForOneCoordinate(coordinate.lng, coordinate.lat)
//   );
// };
export const changeCoordinatesFromWGS84ToLV95 = (pWGS84Coordinates: LatLng[][]): XYCoordinate[][] => {
  const result = pWGS84Coordinates.map((polygon) =>
    polygon.map((coordinate) => wgs84ToLv95ForOneCoordinate(coordinate.lng, coordinate.lat))
  );
  return result;
};

/**
 * Rounds Coordinates to 8 Digits
 */
export const roundCoordinatesTo8Digits = (pCoordinates: LatLng[]): LatLng[] => {
  return pCoordinates.map((coordinate) => {
    return {
      lat: parseFloat(coordinate.lat.toFixed(8)),
      lng: parseFloat(coordinate.lng.toFixed(8)),
    };
  });
};
